import { ConversationMessageAudience } from '../../../types/conversation.types';
import { SwitchChip, SwitchRow } from './AudienceSwitch.styled';

export type AudienceOption = {
  value: ConversationMessageAudience;
  label: string;
  /** What the composer's field says while this one is picked. */
  placeholder: string;
};

type Props = {
  options: AudienceOption[];
  value: ConversationMessageAudience;
  onChange: (value: ConversationMessageAudience) => void;
};

/** The customer, or ourselves - see the styled module for why chips. */
export const AudienceSwitch = ({ options, value, onChange }: Props) => (
  <SwitchRow role="radiogroup" aria-label="Write to">
    {options.map((option) => (
      <SwitchChip
        key={option.value}
        type="button"
        role="radio"
        aria-checked={option.value === value}
        $selected={option.value === value}
        $tone={option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </SwitchChip>
    ))}
  </SwitchRow>
);
